import ClientInfo from './ClientInfo.vue';

export default ClientInfo;
